import { Drawer, Grid, Hidden, MenuItem, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import LaunchIcon from "@material-ui/icons/Launch";
import MenuIcon from "@material-ui/icons/Menu";
import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import swifthelplogo from "../img/swifthelplogo.svg";
import swifthelpbirdwhite from "../img/swifthelpbirdwhite.svg";

function SwiftNav() {
  const useStyles = makeStyles((theme) => ({
    Navmain: {
      height: "70px",
      position: "fixed",
      width: "100%",
      padding: "5px 40px ",
      backgroundColor: "#938bf2",
      fontWeight: "500",
      [theme.breakpoints.down("md")]: {
        padding: "5px 20px",
      },
      [theme.breakpoints.down("sm")]: {
        padding: "5px 10px",
      },
      zIndex: "1000",
    },
    logo: { width: "200px", marginRight: "0px" },
    navlink: {
      textDecoration: "none",
      color: "white",
      margin: "0px 2%",
      display: "inline-block",
      position: "relative",
      "&:hover": {
        color: "white",
      },
      "&::before": {
        content: "''",
        position: "absolute",
        display: "block",
        width: "100%",
        height: "2px",
        bottom: "1px",
        left: "0",
        backgroundColor: "rgb(255,255,255,0.7)",
        transform: "scaleX(0)",
        transition: "transform 0.3s ease",
      },
      "&:hover&::before": {
        transform: "scaleX(1)",
      },
    },
    drawerlink: {
      textDecoration: "none",
      color: "#646f79",
      width: "100%",
      "&:hover": {
        color: "#7a6eff",
      },
    },
    navexit: {
      textDecoration: "none",
      color: "#ffff",
      fontSize: "14px",
      "&:hover": {
        color: "rgb(255,255,255,0.6)",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px",
      },
    },
    navdrawer: {
      width: "200px",
    },
    linkactive: {
      "&::before": {
        content: "''",
        width: "100%",
        height: "2px",
        bottom: "1px",
        left: "0",
        backgroundColor: "#ffff",
        transform: "scaleX(1)",
      },
    },
    drawerlinkactive: {
      color: "#9287FF",
    },
  }));

  const [openDrawer, setOpenDrawer] = useState(false);

  const teachersList = [
    "answer-sheet-topics",
    "key-idea-topics",
    "create-answer-key-topic",
    "different-answer-types-topics",
    "view-and-send",
    "handwriting-topics",
    "scanning-paper-answer-sheets-topics",
    "help-options",
  ];
  const studentsList = [
    "getting-started-topics",
    "taking-assessments-topics",
    "student-help",
  ];

  const location = useLocation();
  const { pathname } = location;
  const classes = useStyles();
  return (
    <>
      <Drawer open={openDrawer} onClose={() => setOpenDrawer(false)}>
        <div className={classes.navdrawer}>
          <MenuItem onClick={() => setOpenDrawer(false)}>
            <NavLink
              activeClassName={classes.drawerlinkactive}
              className={classes.drawerlink}
              exact
              to="/classic"
            >
              <Typography variant="subtitle1">Home</Typography>
            </NavLink>
          </MenuItem>
          <MenuItem onClick={() => setOpenDrawer(false)}>
            <NavLink
              activeClassName={classes.drawerlinkactive}
              className={classes.drawerlink}
              isActive={() => {
                return teachersList.some((el) => pathname.includes(el));
              }}
              to="/help-options"
            >
              <Typography variant="subtitle1">Teacher Help</Typography>
            </NavLink>
          </MenuItem>
          <MenuItem onClick={() => setOpenDrawer(false)}>
            <NavLink
              activeClassName={classes.drawerlinkactive}
              className={classes.drawerlink}
              isActive={() => {
                return studentsList.some((el) => pathname.includes(el));
              }}
              to="/student-help"
            >
              <Typography variant="subtitle1">Student Help</Typography>
            </NavLink>
          </MenuItem>
          <MenuItem onClick={() => setOpenDrawer(false)}>
            <NavLink
              activeClassName={classes.drawerlinkactive}
              className={classes.drawerlink}
              to="/questions"
            >
              <Typography variant="subtitle1">FAQ</Typography>
            </NavLink>
          </MenuItem>
          <MenuItem onClick={() => setOpenDrawer(false)}>
            <NavLink
              activeClassName={classes.drawerlinkactive}
              className={classes.drawerlink}
              to="/webinar"
            >
              <Typography variant="subtitle1">Webinars</Typography>
            </NavLink>
          </MenuItem>
          <MenuItem onClick={() => setOpenDrawer(false)}>
            <NavLink
              activeClassName={classes.drawerlinkactive}
              className={classes.drawerlink}
              to="/videos"
            >
              <Typography variant="subtitle1">Videos</Typography>
            </NavLink>
          </MenuItem>
        </div>
      </Drawer>
      <Hidden smDown>
        <Grid
          className={classes.Navmain}
          container
          justifyContent="space-between"
          alignItems="flex-end"
          style={{ flexWrap: "nowrap" }}
        >
          <Grid item>
            <Link to="/">
              <img className={classes.logo} src={swifthelplogo} alt="logo" />
            </Link>
          </Grid>
          <Grid
            item
            container
            justifyContent="center"
            style={{
              paddingBottom: "2px",
            }}
          >
            <NavLink
              activeClassName={classes.linkactive}
              className={classes.navlink}
              exact
              to="/classic"
            >
              <Typography variant="subtitle1">Home</Typography>
            </NavLink>

            <NavLink
              activeClassName={classes.linkactive}
              className={classes.navlink}
              isActive={() => {
                return teachersList.some((el) => pathname.includes(el));
              }}
              to="/help-options"
            >
              <Typography variant="subtitle1">Teacher Help</Typography>
            </NavLink>

            <NavLink
              activeClassName={classes.linkactive}
              className={classes.navlink}
              isActive={() => {
                return studentsList.some((el) => pathname.includes(el));
              }}
              to="/student-help"
            >
              <Typography variant="subtitle1">Student Help</Typography>
            </NavLink>

            <NavLink
              activeClassName={classes.linkactive}
              className={classes.navlink}
              to="/questions"
            >
              <Typography variant="subtitle1">FAQ</Typography>
            </NavLink>

            <NavLink
              activeClassName={classes.linkactive}
              className={classes.navlink}
              to="/webinar"
            >
              <Typography variant="subtitle1">Webinars</Typography>
            </NavLink>
            <NavLink
              activeClassName={classes.linkactive}
              className={classes.navlink}
              to="/videos"
            >
              <Typography variant="subtitle1">Videos</Typography>
            </NavLink>
          </Grid>
          <Grid
            item
            style={{
              flexShrink: "0",
              paddingBottom: "3px",
            }}
          >
            <a
              className={classes.navexit}
              href="https://goswiftgrade.com/"
              target="_blank"
              rel="noreferrer noopener"
            >
              Go to Swiftgrade{" "}
              <LaunchIcon
                fontSize="inherit"
                style={{
                  verticalAlign: "middle",
                  display: "inline-flex",
                  paddingBottom: "3px",
                }}
              />
            </a>
          </Grid>
        </Grid>
      </Hidden>
      <Hidden xsDown mdUp>
        <Grid
          className={classes.Navmain}
          container
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item container xs={4} justifyContent="flex-start">
            <MenuIcon
              style={{ cursor: "pointer", fontSize: "40px", color: "white" }}
              onClick={() => setOpenDrawer(true)}
            />
          </Grid>
          <Grid item container justifyContent="center" xs={4}>
            <Link to="/">
              <img className={classes.logo} src={swifthelplogo} alt="logo" />
            </Link>
          </Grid>
          <Grid item xs={4} justifyContent="flex-end" container>
            <a
              className={classes.navexit}
              href="https://goswiftgrade.com/"
              target="_blank"
              rel="noreferrer noopener"
            >
              Go to Swiftgrade{" "}
              <LaunchIcon
                fontSize="inherit"
                style={{
                  verticalAlign: "middle",
                  display: "inline-flex",
                  paddingBottom: "3px",
                }}
              />
            </a>
          </Grid>
        </Grid>
      </Hidden>
      <Hidden smUp>
        <Grid className={classes.Navmain} container alignItems="center">
          <Grid item container xs={4} justifyContent="flex-start">
            <Link to="/">
              <img
                style={{ width: "50px" }}
                src={swifthelpbirdwhite}
                alt="logo"
              />
            </Link>
          </Grid>
          <Grid
            item
            container
            xs={4}
            justifyContent="center"
            style={{ paddingLeft: "15px" }}
          >
            <a
              className={classes.navexit}
              href="https://goswiftgrade.com/"
              target="_blank"
              rel="noreferrer noopener"
            >
              Swiftgrade{" "}
              <LaunchIcon
                fontSize="inherit"
                style={{
                  verticalAlign: "middle",
                  display: "inline",
                  paddingBottom: "3px",
                }}
              />
            </a>
          </Grid>
          <Grid item xs={4} container justifyContent="flex-end">
            <MenuIcon
              style={{
                cursor: "pointer",
                fontSize: "35px",
                color: "white",
              }}
              onClick={() => setOpenDrawer(true)}
            />
          </Grid>
        </Grid>
      </Hidden>
    </>
  );
}

export default SwiftNav;
